import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './Resume.scss';
import '../../app/App.scss';
import '../../components/badges/Badge.scss';

import Github from './resumeimages/github.svg';
import LinkedIn from './resumeimages/linkedin.svg';
import Globe from '../../assets/globe-solid.svg';

const ALL_SKILLS = [
  'TypeScript', 'JavaScript', 'React', 'React Native', 'Next.js', 'Node.js',
  'PostgreSQL', 'Docker', 'CI/CD', 'Git', 'Microservices',
  'Headless CMS', 'Web3', 'UI/UX Design',
  'eCommerce', 'Shopify', 'D2C / B2B', 'Conversion Optimization', 'Payment Integration',
  'Adobe Creative Suite', 'Affinity Suite', 'Spreadsheets',
];

const JOBS = [
  {
    company: 'Pistachio Fi',
    role: 'Chief Technology Officer',
    type: 'Full-time',
    dates: 'Apr 2023 - Mar 2026 (3 years)',
    url: 'https://pistachio.fi',
    summary: 'Led development of a Web3 self-custody wallet platform with React Native and Node.js as sole principal engineer',
    bullets: [
      { text: 'Architected a production-ready Web3 self-custody wallet platform as sole principal engineer', skills: ['Web3', 'React Native', 'Node.js', 'Docker', 'Microservices', 'CI/CD'] },
      { text: 'Built full-stack React Native and Node.js platform with Docker microservices and CI/CD', skills: ['React Native', 'Node.js', 'Docker', 'Microservices', 'CI/CD'] },
      { text: 'Integrated MPC wallet technology and biometric authentication to strengthen platform security', skills: ['Web3', 'React Native'] },
    ],
  },
  {
    company: 'RS-R USA',
    role: 'Project Lead, Full Stack Engineer',
    type: 'Contract',
    dates: 'Mar 2019 - Present (7 years)',
    url: 'https://rs-r.com',
    summary: 'Led development and maintenance of D2C/B2B eCommerce platforms with focus on conversion optimization and UX',
    bullets: [
      { text: 'Spearheaded a D2C/B2B eCommerce platform focused on security, performance, and order management', skills: ['eCommerce', 'D2C / B2B', 'TypeScript', 'React', 'Payment Integration', 'Headless CMS'] },
      { text: 'Boosted conversion rates through strategic UX enhancements and data-driven optimizations', skills: ['Conversion Optimization', 'UI/UX Design', 'TypeScript'] },
      { text: 'Designed UI/UX for RMA management, customer service workflows, and technical documentation', skills: ['UI/UX Design', 'React', 'TypeScript'] },
      { text: 'Maintained legacy WordPress eCommerce application, ensuring performance, security, and uptime', skills: ['eCommerce', 'PHP', 'WordPress'] },
    ],
  },
  {
    company: 'Mint Gold Dust',
    role: 'Full Stack Engineer',
    type: 'Full-time',
    dates: 'Aug 2021 - Feb 2022 (7 months)',
    url: 'https://mintgolddust.com',
    summary: 'Built and maintained Web3-integrated microservices using Next.js and React for an NFT marketplace',
    bullets: [
      { text: 'Built and maintained Next.js and React microservices, improving performance and scalability', skills: ['Next.js', 'React', 'Microservices', 'TypeScript'] },
      { text: 'Drove technical product development and authored comprehensive engineering documentation', skills: ['Git', 'CI/CD'] },
      { text: 'Integrated blockchain functionality via Web3 providers including WalletConnect and Ethers', skills: ['Web3', 'JavaScript', 'WalletConnect', 'Ethers'] },
    ],
  },
  {
    company: 'Candlelit Candle Co',
    role: 'Owner',
    type: 'Full-time',
    dates: 'Sep 2018 - Nov 2021 (3 years 3 months)',
    summary: 'Founded and grew a profitable D2C candle business with a custom e-commerce site and marketing strategy',
    bullets: [
      { text: 'Founded Candlelit Candle Co, scaling a side project into a profitable D2C venture', skills: ['eCommerce', 'D2C / B2B', 'TypeScript', 'Spreadsheets'] },
      { text: 'Designed and built a custom e-commerce website to showcase and sell hand-poured candles', skills: ['eCommerce', 'UI/UX Design', 'JavaScript', 'TypeScript'] },
      { text: 'Led all marketing including content creation and retargeting campaigns; achieved profitability solo', skills: ['Conversion Optimization', 'Adobe Creative Suite', 'Affinity Suite'] },
    ],
  },
  {
    company: 'Kyle Diggs Development and Design',
    role: 'Technical Partner, Full Stack Engineer',
    type: 'Self-employed',
    dates: 'Jan 2015 - Dec 2023 (9 years)',
    url: 'https://kylediggs.com',
    summary: 'Developed 100+ client websites and provided comprehensive graphic design services over 9 years',
    bullets: [
      { text: 'Built 100+ client websites from scratch: blogs, landing pages, internal tools, and eCommerce sites', skills: ['JavaScript', 'React', 'eCommerce', 'TypeScript', 'Headless CMS'] },
      { text: 'Designed and implemented custom headless CMS solutions tailored to client needs', skills: ['Headless CMS', 'JavaScript'] },
      { text: 'Led SEO and omni-channel marketing strategies, executing cohesive digital and physical campaigns', skills: ['Conversion Optimization', 'Adobe Creative Suite'] },
      { text: 'Partnered with small businesses on brand development; designed logos, graphics, and site layouts', skills: ['Adobe Creative Suite', 'UI/UX Design'] },
      { text: 'Delivered end-to-end print and design solutions across full project lifecycles', skills: ['Adobe Creative Suite', 'Affinity Suite', 'Printing'] },
    ],
  },
  {
    company: 'Desert Fulfillment and Logistics',
    role: 'Ecommerce Project Manager',
    type: 'Full-time',
    dates: 'Jun 2018 - Sep 2019 (1 year 4 months)',
    summary: 'Managed e-commerce operations and maintained 12+ Shopify sites for a fulfillment company',
    bullets: [
      { text: 'Managed system administration and networking for e-commerce operations', skills: ['eCommerce'] },
      { text: 'Oversaw development and maintenance of 12+ Shopify sites, enhancing UX and product visibility', skills: ['Shopify', 'eCommerce'] },
      { text: 'Collaborated with marketing on product launches and logistics teams to improve workflows', skills: ['eCommerce', 'Spreadsheets'] },
    ],
  },
  {
    company: 'Gamer Queue LLC',
    role: 'Chief Technology Officer',
    type: 'Full-time',
    dates: 'Jun 2017 - Nov 2018 (1 year 6 months)',
    summary: 'Built a social network for gamers from the ground up using React and Django as CTO',
    bullets: [
      { text: 'Served as CTO and lead developer, focusing on building a social network for gamers', skills: ['JavaScript', 'React', 'Python', 'Django'] },
      { text: 'Designed and developed the entire platform using Python, Django, Google App Engine, and React', skills: ['React', 'JavaScript', 'PostgreSQL', 'Django'] },
      { text: 'Built responsive mobile version of the platform, improving accessibility across devices', skills: ['UI/UX Design', 'React', 'JavaScript', 'Python', 'Django'] },
    ],
  },
  {
    company: 'Evasive Motorsports',
    role: 'Web Development/Design Internship',
    type: 'Internship',
    dates: 'Sep 2015 - Feb 2016 (6 months)',
    url: 'https://evasivemotorsports.com',
    summary: 'Modernized website from Flash to HTML5/CSS3 and managed eCommerce product listings',
    bullets: [
      { text: 'Updated outdated Flash elements to modern CSS3 and HTML5 standards, enhancing website performance', skills: ['JavaScript'] },
      { text: 'Reformatted site sections and managed eCommerce product listings using Miva platform', skills: ['eCommerce'] },
    ],
  },
  {
    company: 'The Walt Disney Company',
    role: 'Food Service, Trainer, Employee Safety, Training Documentation',
    type: 'Part-time',
    dates: 'Jul 2014 - Nov 2017 (3 years 5 months)',
    summary: 'Created training documentation and safety materials for onboarding new hires',
    bullets: [
      { text: 'Developed comprehensive training documentation and materials for new hires to enhance onboarding', skills: [] },
      { text: 'Created job aids for new tasks, ensuring staff adhered to safety protocols', skills: [] },
    ],
  },
  {
    company: 'Anthony Cioffi Design',
    role: 'Graphic Design Intern',
    type: 'Apprenticeship',
    dates: 'Nov 2013 - Jul 2014 (9 months)',
    summary: 'Completed hundreds of hours of design work under mentorship, mastering the Adobe Creative Suite',
    bullets: [
      { text: 'Completed hundreds of hours of design work under direct mentorship with Anthony Cioffi', skills: ['Adobe Creative Suite', 'Affinity Suite'] },
      { text: 'Designed and produced 50+ assets for production and sales; mastered the full Adobe suite', skills: ['Adobe Creative Suite', 'Affinity Suite'] },
    ],
  },
];

function JobEntry({ url, children }) {
  const domain = url ? new URL(url).hostname.replace(/^www\./, '') : null;
  return (
    <div className="job-entry">
      <div className="job-content">
        {children}
      </div>
      {url && <>
        <a className="job-link" href={url} target="_blank" rel="noopener noreferrer">
          <img src={Globe} alt="" />
          <span>{domain}</span>
        </a>
        <div className="job-qr">
          <span>{domain}</span>
          <QRCodeSVG value={url} size={26} level="M" />
        </div>
      </>}
    </div>
  );
}

function FilteredJob({ job, isCompact, selectedSkills }) {
  const isBulletVisible = (bullet) => {
    if (!isCompact) return true;
    return bullet.skills.some(skill => selectedSkills.has(skill));
  };

  const visiblePrimary = job.bullets.filter(isBulletVisible);
  const visibleSecondary = job.secondaryRole
    ? job.secondaryRole.bullets.filter(isBulletVisible)
    : [];

  return (
    <JobEntry url={job.url}>
      <h5>{job.company} - <span className="role">{job.role}</span></h5>
      <span>{job.type} - {job.dates}</span>
      {visiblePrimary.length > 0 && (
        <ul>
          {visiblePrimary.map((bullet, i) => <li key={i}>{bullet.text}</li>)}
        </ul>
      )}
      {job.secondaryRole && visibleSecondary.length > 0 && (
        <>
          <span className="secondary-role">{job.secondaryRole.title}</span>
          <ul>
            {visibleSecondary.map((bullet, i) => <li key={i}>{bullet.text}</li>)}
          </ul>
        </>
      )}
    </JobEntry>
  );
}

export default function ResumePage() {
  const [isPrinting, setIsPrinting] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState(() => new Set(ALL_SKILLS));

  const toggleSkill = (skill) => {
    setSelectedSkills(prev => {
      const next = new Set(prev);
      if (next.has(skill)) next.delete(skill);
      else next.add(skill);
      return next;
    });
  };

  const allSelected = selectedSkills.size === ALL_SKILLS.length;

  const isFiltering = selectedSkills.size < ALL_SKILLS.length;

  return (<section id="ResumePage">
    <div className="resume-container">
      <div className="body col">
        <div className="col">
          <div className="name-row">
            <h1>Kyle Diggs</h1>
            <div className="contact-top-right">
              <h5>Contact@KyleDiggs.com</h5>
              <h5>{isPrinting ? <span className="print-only phone-number">+1 (760) 880-0723</span> : null}</h5>
            </div>
          </div>
          <div className="head-row">
            <div className="about">
              <p>Senior software engineer and technical leader with extensive experience architecting enterprise-grade applications. Specializing in full-stack development, system architecture, and guiding teams. I excel at translating business requirements into technical solutions, carving out easy to maintain systems, and improving development processes.</p>
            </div>
            <div className="contact">
              <div className="col">
                <a className="head-button print-only" href="https://kylediggs.com" target="_">
                  <img src={Globe} alt="Globe" />
                  <span>KyleDiggs.com</span>
                </a>
                <a className="head-button" href="https://github.com/Kyle772" target="_"><img src={Github} alt="Github" /><span>/Kyle772 <br />10 commits/day average!</span></a>
                <a className="head-button" href="https://www.linkedin.com/in/kylediggs/" target="_"><img src={LinkedIn} alt="LinkedIn" /><span>/in/KyleDiggs</span></a>
              </div>
            </div>
          </div>
        </div>
        <div className="resume-flex-con">
          <h4>Skills</h4>
          <button className="select-all-btn screen-only" onClick={() => {
            setSelectedSkills(allSelected ? new Set() : new Set(ALL_SKILLS));
          }}>
            {allSelected ? 'Deselect All' : 'Select All'}
          </button>
        </div>
        <div className="skills-row">
          {ALL_SKILLS.map(skill => (
            <span
              key={skill}
              className={`skill-pill interactive${!selectedSkills.has(skill) ? ' deselected' : ''}`}
              onClick={() => toggleSkill(skill)}
            >
              {skill}
            </span>
          ))}
        </div>
        <div className="resume-flex-con">
          <h4>Work Experience</h4>
        </div>
        {JOBS.map((job) => (
            <FilteredJob
            key={job.company}
            job={job}
            isCompact={isFiltering}
            selectedSkills={selectedSkills}
          />
        ))}
      </div>
    </div>
    <button className="print-badge" onClick={() => {
      setIsPrinting(true);
      window.print();
    }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zm-16-88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z" />
      </svg>
      <div>
        <span>This page is print friendly!</span>
        <span>Click here to print</span>
      </div>
    </button>
  </section>);
}
